import styled from 'styled-components';
import { Flex } from '@pancakeswap/uikit';

export const ScrollableRow = styled.div`
width: 100%;
overflow-x: auto;
padding: 16px 0;
white-space: nowrap;
::-webkit-scrollbar {
  display: none;
}
`;

export const CopyButtonContainer = styled.div`
margin-top: -6px;
display: flex;
align-items: center;
flex-direction: row;
`;


export const ResponsiveFlex = styled(Flex)`
  flex-direction: column;
  align-items: center;
  gap: 20px;

  @media (min-width: 768px) { // Adjust the breakpoint as needed
    flex-direction: row;
    justify-content: center;
  }
`;

export const InputPanel = styled.div`
@media (max-width: 767px) {
& {
  //width:130px;
}
}
  display: flex;
  width: 100%;
  flex-flow: column;
  position: relative;
  padding: 10px;
  // background-color: ${({ theme }) => theme.colors.backgroundAlt};
  border: solid 1px ${({ theme }) => theme.colors.primary};
  border-radius: 15px;
  z-index: 1;
`

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed; // Use fixed to position relative to the viewport
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); // Optional: for a semi-transparent backdrop
  z-index: 999; // Ensure it's above other content
`;


export const Container = styled.div`
  padding: 2rem;
  font-family: 'Arial', sans-serif;
  text-align: center; 
  max-width: 550px;
  margin: 0 auto;
`;

export const Section = styled.section`
border: solid 1px ${({ theme }) => theme.colors.primary};
border-radius: 15px;
  padding: 1.5rem;
  margin-bottom: 1rem;
`;

export const DeployedTokenSection = styled.section`
border-radius: 15px;
  padding: 1.5rem;
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #E0E0E0;
  border-radius: 15px;
  text-align: center;
`;


export const FileInputContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const FileName = styled.div`
  border: 1px solid #E0E0E0;
  border-radius: 15px;
  padding: 0.75rem;
  margin-right: 0.5rem;
  flex-grow: 1;
  color: white;
`;

export const ResumeSection = styled.div`
  border: 1px solid #E0E0E0;
  border-radius: 15px;
  padding: 1rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  color: white;
  text-align: left; 
`;